<template>
    <div v-loading="loading">
        <div :key="table.Name" v-for="table in model.MainTables">
            <el-row :gutter="20">
                <el-col :span="tableMain">
                    <el-card class="m-t-20 el-card--with-table">
                        <div slot="header">
                            <div v-if="filters" class="float-right">
                                <small class="font-weight-bold m-r-10">Выберите фильтр:</small>
                                <el-select @change="handleChangeFilter" v-model="filterActive" :default-first-option="true" placeholder="Выберите фильтр" class="select-filter">
                                    <el-option
                                            v-for="(row, index) in filters"
                                            :key="index"
                                            :label="row.Name"
                                            :value="index">
                                    </el-option>
                                </el-select>
                            </div>

                            <h2>{{table.DisplayName}}</h2>

                            <div v-loading="loadingFilters" v-if="filters">
                                <!-- eslint-disable-next-line -->
                                <div v-if="filterActive === index" v-for="(filterSet, index) in filters" :key="index" class="filters">
                                    <!-- eslint-disable-next-line -->
                                    <div v-for="filter in filterSet.DataMemberDescriptions" v-if="filterSet.DataMemberDescriptions" :key="filter.DataMember">
                                        <el-select filterable v-if="filter.StandardValues" @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true">
                                            <el-option
                                                    v-for="(row, index) in filter.StandardValues"
                                                    :key="index"
                                                    :label="row"
                                                    :value="row">
                                            </el-option>
                                        </el-select>
                                        <el-input v-else @change="handleChange" v-model="formDynamic[filter.DataMember]" :placeholder="filter.DisplayName" class="w-100" :clearable="true"></el-input>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <el-table
                                v-loading="loading"
                                :data="table.Rows"
                                v-if="table.Rows"
                                :row-class-name="tableRowClassName"
                                :row-style="tableRowStyle"
                                :cell-class-name="tableRowClassName"
                                :cell-style="tableRowStyle"
                                :highlight-current-row="true"
                                @row-click="showDetails"
                        >
                            <!-- eslint-disable-next-line -->
                            <el-table-column v-if="columnVisibility(header, $index)"
                                    :key="header.DataMember"
                                    v-for="(header, $index) in table.Headers"
                                    :prop="'Cells.' + header.DataMember"
                                    :label="header.DisplayName"
                                    :title="header.Description"
                            >
                                <template slot-scope="scope">
                                    <div v-if="scope.row.Cells.find(x => x.DataMember === header.DataMember).Value">
                                        <div v-if="table.Headers[$index].DataType === 'DateTime'">
                                            <table-date :date="scope.row.Cells.find(x => x.DataMember === header.DataMember).Value" />
                                        </div>
                                        <div v-else-if="table.Headers[$index].DataType === 'Decimal'">
                                            {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value | rubles }}
                                        </div>
                                        <div v-else>
                                            {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value}}
                                        </div>
                                    </div>
                                    <div v-else>0</div>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>

                    <div class="m-t-20 text-center">
                        <el-pagination
                                background
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page.sync="page"
                                :page-sizes="[10, 20, 100, 200, 300, 400]"
                                :page-size="pageSize"
                                layout="sizes, prev, pager, next, total"
                                :total="table.Total">
                        </el-pagination>
                    </div>
                </el-col>
                <el-col v-if="detailedRow" :span="tableDetailed">
                    <el-card class="m-t-20">
                        <h2 class="m-b-20">{{detailedTitle}}
                            <span class="d-flex float-right">
                                <el-button icon="icon-close" style="margin-top: -10px;" size="mini" type="link" @click="closeDetails"></el-button>
                            </span>
                        </h2>
                        <div v-if="detailedRow && detailedRow.Cells">
                            <el-row :gutter="20" v-for="(row, key) in detailedList" v-bind:key="key">
                                <template v-if="table.Headers.find(x => x.DataMember === row.DataMember).DisplayName">
                                    <el-col :span="8" class="detailed-name font-weight-bold">
                                        {{table.Headers.find(x => x.DataMember === row.DataMember).DisplayName}}:
                                    </el-col>
                                    <el-col :span="16" class="detailed-value">
                                        <div v-if="table.Headers.find(x => x.DataMember === row.DataMember).DataType === 'DateTime'">
                                            {{ detailedRow.Cells.find(x => x.DataMember === row.DataMember).Value | date }}
                                        </div>
                                        <div v-else-if="table.Headers.find(x => x.DataMember === row.DataMember).DataType === 'Decimal'">
                                            {{detailedRow.Cells.find(x => x.DataMember === row.DataMember).Value | rubles }}
                                        </div>
                                        <div v-else>
                                            {{detailedRow.Cells.find(x => x.DataMember === row.DataMember).Value}}
                                        </div>
                                    </el-col>
                                </template>
                            </el-row>
                        </div>
                    </el-card>
                </el-col>
            </el-row>
        </div>

        <el-card class="m-t-20 el-card--with-table" v-if="model.SummaryTable && model.SummaryTable.Headers">
            <div slot="header">
                <h2 class="m-b-0">{{model.SummaryTable.DisplayName}}</h2>
            </div>
            <el-table
                    :data="model.SummaryTable.Rows"
                    :row-class-name="tableRowClassName"
                    :row-style="tableRowStyle"
                    :cell-class-name="tableRowClassName"
                    :cell-style="tableRowStyle"
                    :highlight-current-row="true"
            >
                <!-- eslint-disable-next-line -->
                <el-table-column v-if="columnVisibility(header, $index)"
                                 :key="header.DataMember"
                                 v-for="(header, $index) in model.SummaryTable.Headers"
                                 :prop="'Cells.' + header.DataMember"
                                 :label="header.DisplayName"
                                 :title="header.Description"
                >
                    <template slot-scope="scope">
                        <div v-if="scope.row.Cells.find(x => x.DataMember === header.DataMember).Value">
                            <div v-if="model.SummaryTable.Headers[$index].DataType === 'DateTime'">
                                <table-date :date="scope.row.Cells.find(x => x.DataMember === header.DataMember).Value" />
                            </div>
                            <div v-else-if="model.SummaryTable.Headers[$index].DataType === 'Decimal'">
                                {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value | rubles }}
                            </div>
                            <div v-else>
                                {{scope.row.Cells.find(x => x.DataMember === header.DataMember).Value}}
                            </div>
                        </div>
                    </template>
                </el-table-column>
            </el-table>


        </el-card>

    </div>
</template>

<script>
    export default {
        props: ['name', 'form', 'formKey', 'autoFetch'],
        data() {
            return {
                model: {},
                loading: false,
                loadingFilters: false,
                page: 1,
                pageSize: 10,
                total: 0,
                detailedTitle: '',
                detailedMode: false,
                tableMain: 24,
                tableDetailed: 0,
                detailedRow: {},
                filters: null,
                filterActive: 0,
                formDynamic: {}
            }
        },
        computed: {
            detailedList: function () {
                return this.detailedRow.Cells.filter(x => x.Value !== '')
            }
        },
        created () {
            if (this.autoFetch) {
                this.getReportFiltering()
                this.getData()
            }
        },
        methods: {
            handleChange () {
                this.getData()
            },
            getReportFiltering () {
                this.loadingFilters = true
                let request = {
                    Name: 'GetReportFiltering',
                    ReportName: this.name
                }

                this.$api.Main.getReportFiltering(request).then(response => {
                    if (response.ErrorString) {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                    }
                    else {
                        console.log(response)
                        this.filters = response.FilteringDescriptions
                    }
                    this.loadingFilters = false
                }).catch (() => {
                    this.loadingFilters = false
                })
            },
            columnVisibility (header, index) {
                if (header.ColumnVisible === false) {
                    return false
                }

                if (this.detailedMode) {
                    if (index < 5) {
                        return true
                    } else {
                        return false
                    }
                }
                else {
                    return true
                }
            },
            tableRowClassName({row}) {
                return row.ColorScheme
            },
            tableRowStyle ({row}) {
                if (row.BackgroundColor || row.ForegroundColor) {
                    return { backgroundColor: row.BackgroundColor, color: row.ForegroundColor }
                }
                else return ''
            },
            getData () {
                this.loading = true

                let request = {
                    Name: "GetReport",
                    ReportName: this.name,
                    TimeBegin: this.form.Date[0],
                    TimeEnd: this.form.Date[1],
                    Page: this.page,
                    PageSize: this.pageSize,
                }

                if (this.filters) {
                    request.Filtration = this.filters[this.filterActive].Name
                    // делаем вместо нормального json, объект с Field-Value
                    request.ShortFilter = Object.entries(this.formDynamic).map(row => { return { Field: row[0], Value: row[1] } })
                }

                request = Object.assign({...request}, {...this.form})

                this.$api.Main.getReport(this.name, request).then(response => {
                    if (response.ErrorString) {
                        this.$message({
                            message: response.ErrorString,
                            type: 'error'
                        })
                        this.loading = false
                    }
                    else {
                        console.log(response)
                        this.model = response.Report
                        this.loading = false
                    }
                }).catch (() => {
                    this.loading = false
                })
            },
            showDetails (row) {
                this.setDetailedMode(true, row)
            },
            closeDetails () {
                this.setDetailedMode(false)
            },
            setDetailedMode (action, row) {
                if (action) {
                    console.log(row)
                    this.detailedRow = row
                    this.detailedTitle = (row.Cells.find(x => x.DataMember === 'Customer') ? row.Cells.find(x => x.DataMember === 'Customer').Value : 'Подробности')
                    this.detailedMode = true
                    this.tableMain = 12
                    this.tableDetailed = 12
                } else {
                    this.detailedRow = {}
                    this.detailedMode = false
                    this.tableMain = 24
                    this.tableDetailed = 0
                }
            },
            handleSizeChange (val) {
                this.pageSize = val
                this.getData()
            },
            handleCurrentChange (val) {
                this.page = parseInt(val)
                this.getData()
            },
            handleChangeFilter () {
                this.formDynamic = {}
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .filters {
        margin-top: 20px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat( auto-fit, minmax(250px, 1fr) );
        grid-column-gap: 20px;
    }

    .select-filter {
        margin-top: -10px;
        min-width: 250px;
    }

    .Default td {

    }
    .Alarm td {
        background-color: #ffabad;
        color: #7c0b00;
    }
    .Disabled td {
        background-color: #eee;
        color: #666;
    }
    .detailed-name {
        background-color: #F5F6F9;
        padding: 10px 2px;
        color: #7F8188;
        border-bottom: 1px solid #ebeef5;
    }
    .detailed-value {
        padding: 10px 2px;
        border-bottom: 1px solid #ebeef5;
    }
</style>
